/*
 * Copyright (C) 2025 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { InjectionToken } from '@angular/core';
import { PortfolioUpdateRequestModel } from '@app/app/page-modules/portfolio/models';
import { Page } from '@app/app/shared/models/page';
import { PortfolioModel } from '@app/app/shared/services/portfolio/api-data.service';
import { ObservableResult } from 'src/app/shared/store';

export const PORTFOLIO_DATA_SERVICE = new InjectionToken<PortfolioDataService>('[Portfolio] PortfolioDataService');

export interface PortfolioDataService {
  getPortfolio(portfolioId: string): ObservableResult<PortfolioModel>;

  getUserPortfolios(page: number, pageSize: number): ObservableResult<Page<PortfolioModel>>;

  getPublicPortfolio(portfolioId: string): ObservableResult<PortfolioModel>;

  updatePortfolio(portfolioId: string, request: PortfolioUpdateRequestModel);

  createPortfolio(request: PortfolioUpdateRequestModel): ObservableResult<PortfolioModel>;

  updatePortfolioVisibility(portfolioId: string, isVisible: boolean): ObservableResult<PortfolioModel>;

  deletePortfolio(portfolioId: string): ObservableResult<void>;

  updatePortfolioCohortShare(portfolioId: string, shared: boolean): ObservableResult<PortfolioModel>;
}
